import { CUSTOMER_JOURNEY_NEWS_CATEGORY_ERROR } from '../const';

function action() {
  return { type: CUSTOMER_JOURNEY_NEWS_CATEGORY_ERROR };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyNewsCategoryError.js